import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_y6mta332qy: FaireBrandEntity = {
  token: "b_y6mta332qy",
  type: "brand",
  name: "Choice Blooms",
  avatarUrl:
    "https://cdn.faire.com/fastly/5bb194bff060c60edb50473298d739f171db13cca9ab65f38b72642c4a566620.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/51c34ca3646aa294471995a1fdd12e8bc4d1d53c1b256820affcae46dba7c166.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5bb194bff060c60edb50473298d739f171db13cca9ab65f38b72642c4a566620.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/51c34ca3646aa294471995a1fdd12e8bc4d1d53c1b256820affcae46dba7c166.jpeg",
  location: "West Hills, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "Clean scents, cool glassware. Top-quality fragrance + essential oils combined with natural hemp coconut soy blend wax + bees-waxed hemp wick in a reusable groovy glass vessel make up our candles. Made with fragrance + essential oils that are made better: NO parabens, phthalates, mutagens, carcinogens, and cruelty free.\n\nBy purchasing from us, you agree to our Minimum Advertised Pricing (MAP) in stores + online listed per product. If you do not follow our MSRP pricing policy you will no longer be able to sell our products. Purchasing as a wholesale reseller from us means you are an extension of our business. Please act ethically on our behalf selling our products.\n\nOrders are charged a $2.00 per 📦 shipping/handling rate. Larger orders requiring more than one 📦- each 📦 is $2.00. \nDue to high risk of carrier breakage, liquid and glassware items are insured and added to your order as a handling fee. \n\nWhy is the 7 oz leaving? \nWith a 30% tariff and the rising costs of running a small business, the 7 oz size just doesn’t add up anymore. We’ve rolled out 3 brand-new sizes that bring you more value, more burn time, and the same groovy glow. If you are considering adding CB to your assortment, we recommend starting with the new sizes since the glass type/quality is different from the 7 oz size. \n\nFull product details on www.choiceblooms.com or reach out to us at: [redacted-email]",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:25.627Z",
    importedBy: "entity-db-cli",
  },
};
